"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:7.4.0'] && _();
}
catch (e) { }
